import { DefaultValues } from 'react-hook-form'
import { InferType, mixed, object, string } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'

import { PaymentTypeIntention, TestGroup } from 'types'
import { getTodayDate } from 'utils'

export const policyStartDateDefaultValues = {
  inceptionDate: undefined,
  paymentTypeIntention: undefined,
} satisfies DefaultValues<PolicyStartDateSchemaType>

export const getPolicyStartDateSchema = ({
  growth_payment_intention_question,
}: {
  growth_payment_intention_question: TestGroup
}) =>
  object({
    inceptionDate: string()
      .test({
        name: 'Is minimal date',
        message: "Your policy start date can't be in the past!",
        test: (inceptionDate) => {
          if (!inceptionDate) {
            return true
          }

          const valueDate = new Date(inceptionDate)

          return getTodayDate() <= valueDate
        },
      })
      .required(requiredMessage),
    ...(growth_payment_intention_question === 'VARIANT'
      ? {
          paymentTypeIntention: mixed<PaymentTypeIntention>().required(requiredMessage),
        }
      : {
          paymentTypeIntention: mixed<PaymentTypeIntention>().optional(),
        }),
  })

export type PolicyStartDateSchemaType = InferType<ReturnType<typeof getPolicyStartDateSchema>>
